import $ from 'jquery';
import { langList } from '../variables';

export interface Lang {
  ja: string;
  en: string;
  cn: string;
}

export interface Tran {
  // 共通
  required: Lang;
  note: Lang;
  agreewithall: Lang;
  Check: Lang;
  back: Lang;
  confirm: Lang;
  click_alert: Lang;
  yes: Lang;
  no: Lang;
  close: Lang;
  hope: Lang;
  nothope: Lang;
  note1: Lang;
  note2: Lang;
  note3: Lang;
  note4: Lang;
  note5: Lang;
  contact: Lang;
  loading: Lang;
  footer_officework:Lang
  footer_tigs:Lang
  footer_ld:Lang
  footer_landd:Lang
  footer_gds:Lang
  footer_kigs:Lang
  footer_pi:Lang
  footer_osaka:Lang
  footer_fukuoka:Lang
  footertel_tigs:Lang
  footertel_ld:Lang
  footertel_landd:Lang
  footertel_gds:Lang
  footertel_kigs:Lang
  footertel_pi:Lang
  footertel_osaka:Lang
  footertel_fukuoka:Lang
  footermail_tigs:Lang
  footermail_ld:Lang
  footermail_landd:Lang
  footermail_gds:Lang
  footermail_kigs:Lang
  footermail_pi:Lang
  footermail_osaka:Lang
  footermail_fukuoka:Lang
  api_fail:Lang
  registration:Lang
  login:Lang
  logout:Lang
  faq_here:Lang
  faq:Lang
  guide:Lang
  mypage_top:Lang

  // エラーメッセージ
  errNeedLogin: Lang;
  errRegisterFavorite: Lang;
  errRemoveFavorite: Lang;
  errPassword1: Lang;
  errPassword2: Lang;
  errPassword3: Lang;
  errPassword4: Lang;
  errPassword5: Lang;
  errEmail1: Lang;
  errEmail2: Lang;
  errEmail3: Lang;
  errPost1: Lang;

  // 招待状/入場用QR 請求フォーム(signup)
  signup_top_title: Lang;
  signup_top_gift_title: Lang;
  top: Lang;
  logintext: Lang;
  loginurl: Lang;
  getcodehead: Lang;
  getcodeouttext: Lang;
  getcodesubmit: Lang;
  notcodehead: Lang;
  notcodehead2: Lang;
  notcodeouttext: Lang;
  notcodesubmit: Lang;
  info1: Lang;
  info2: Lang;
  codeTitle: Lang;
  infotop: Lang;
  firstName: Lang;
  firstNamevl: Lang;
  lastName: Lang;
  lastNamevl: Lang;
  firstNamekana: Lang;
  lastNamekana: Lang;
  email: Lang;
  email_confirm: Lang;
  emailvl: Lang;
  giftnetid: Lang;
  giftnetidvl: Lang;
  emailerrmsg: Lang;
  emailcaution: Lang;
  phoneNumber: Lang;
  phoneNumbervl: Lang;
  password: Lang;
  password_confirm: Lang;
  passwordvl: Lang;
  companyinfo1: Lang;
  companyName: Lang;
  companyNameNotion: Lang;
  companyNameKana: Lang;
  departmentName: Lang;
  positionName: Lang;
  companyNameval: Lang;
  departmentNameval: Lang;
  positionNameval: Lang;
  postalNumber: Lang;
  postalNumberval: Lang;
  prefectures: Lang;
  prefecturesval: Lang;
  address1: Lang;
  address1val: Lang;
  address2: Lang;
  address2val: Lang;
  address3: Lang;
  tel: Lang;
  telval: Lang;
  companyinfo2: Lang;
  industry: Lang;
  industryval: Lang;
  industry_other: Lang;
  industry_otherval: Lang;
  product: Lang;
  productval: Lang;
  product_other: Lang;
  product_otherval: Lang;
  occupation: Lang;
  occupationval: Lang;
  role: Lang;
  roleval: Lang;
  price: Lang;
  priceval: Lang;
  abroad: Lang;
  mail_subscription: Lang;
  dm_subscription: Lang;
  subscribe: Lang;
  preftop: Lang;
  induscatetop: Lang;
  industop: Lang;
  itemcatetop: Lang;
  itemtop: Lang;
  occutop: Lang;
  roletop: Lang;
  pricetop: Lang;
  countriestop: Lang;
  Plannedmarket: Lang;
  emergencyContactValue: Lang;
  emergencyContactValuevl: Lang;
  areaIndexboxval: Lang;
  country: Lang;
  countryval: Lang;
  nextjoin_q: Lang;
  nextjoin_qval: Lang;
  Areconsidering: Lang;
  Areconsideringval: Lang;
  Multipleselectionspossible: Lang;
  purpose: Lang;
  purposeval: Lang;
  Residential_areas: Lang;
  giftnet_topbtn: Lang;

  //各種リンク用URL
  herelogin: Lang;
  note2URL: Lang;
  note4URL: Lang;

  // 完了画面
  completed: Lang;
  thanks: Lang;
  thanksnote1: Lang;
  thanksnote2: Lang;

  // 事前来場者登録ページ
  advance_title:Lang;
  advance_sub1_title:Lang;
  advance_sub1_1:Lang;
  advance_sub1_2:Lang;
  advance_sub1_3:Lang;
  advance_sub1_4:Lang;
  advance_sub2_title:Lang;
  advance_sub2_1:Lang;
  advance_sub2_2:Lang;
  advance_sub2_3:Lang;
  advance_sub3_1:Lang;
  advance_important1:Lang;
  advance_important2:Lang;
  advance_important3:Lang;
  advance_important4:Lang;
  advance_non_member1:Lang;
  advance_non_member2:Lang;
  advance_non_member3:Lang;
  advance_non_member4:Lang;
  advance_member1:Lang;
  advance_member2:Lang;
  advance_member3:Lang;
  advance_member4:Lang;

  // ご来場予定選択ページ
  selection_title:Lang;
  selection_sub1_title:Lang;
  selection_sub2_title:Lang;
  selection_giftnet:Lang;
  apply_now:Lang;
  delete_now:Lang;
  delete_msg:Lang;

  // 事前来場登録（QRコード）のご案内ページ
  // chVisitlist → cv
  cv_title:Lang;
  cv_sub1_title:Lang;
  cv_msg1:Lang;
  cv_msg2:Lang;
  cv_venue:Lang;
  cv_header_title:Lang;
  cv_title1:Lang;

  // ご登録情報の変更ページ
  // chUser → cu
  cu_header_title:Lang;
  cu_title1:Lang;
  cu_title2:Lang;

  // メールアドレスの変更ページ
  // chMail → cm
  cm_header_title:Lang;
  cm_title1:Lang;
  cm_title2:Lang;
  cm_thanks1:Lang;
  cm_thanks2:Lang;
  cm_thanks3:Lang;
  cm_thanks4:Lang;

  // パスワードの変更ページ
  // chPassword → cp
  cp_header_title:Lang;
  cp_title1:Lang;
  cp_title2:Lang;
  cp_title3:Lang;
  cp_thanks1:Lang;

  // 入力欄例
  familyNameplaceholder:Lang;
  lastNameplaceholder:Lang;
  firstNamekanaplaceholder:Lang;
  lastNamekanaplaceholder:Lang;
  emailplaceholder:Lang;
  email_confirmplaceholder:Lang;
  emergencyContactValueplaceholder:Lang;
  passwordplaceholder:Lang;
  password_confirmplaceholder:Lang;
  companyNameplaceholder:Lang;
  companyNameKanaplaceholder:Lang;
  departmentplaceholder:Lang;
  zipCodeplaceholder:Lang;
  cityplaceholder:Lang;
  houseNumberplaceholder:Lang;
  buildingplaceholder:Lang;
  phoneNumberplaceholder:Lang;

  // マイページ
  // mypage → mp
  mp_qr_title:Lang;
  mp_qr_check:Lang;
  mp_qr_title2:Lang;
  mp_qr_explain:Lang;
  mp_qr_info1:Lang;
  mp_qr_info2:Lang;
  mp_qr_info3:Lang;
  mp_qr_visit:Lang;
  no_planed: Lang;
  no_qr: Lang;
  mp_qr_visitbtn:Lang;
  mp_result:Lang;
  mp_resultnum:Lang;
  mp_resultlink:Lang;
  mp_menu1:Lang;
  mp_menu2:Lang;
  mp_menu3:Lang;
  mp_menu1_text:Lang;
  mp_menu2_text:Lang;
  mp_menu3_text:Lang;
  mp_product:Lang;
  mp_namecard:Lang;
  mp_meeting:Lang;
  mp_sfList:Lang;
  mp_login:Lang;
  mp_login2:Lang;
  mp_cardname1:Lang;
  mp_cardname2:Lang;
  mp_cardname3:Lang;
  mp_btnTitle:Lang;
  mp_btn1:Lang;
  mp_btn2:Lang;
  mp_btn3:Lang;

  // ログインページ
  // login → lg
  lg_nopass:Lang;
  lg_or:Lang;
  lg_signup:Lang;
  lg_information:Lang;
  lg_err1:Lang;
  lg_err2:Lang;

  // パスワードの再設定
  // reset-pw → rp
  rp_title:Lang;
  rp_titletext:Lang;
  rp_email:Lang;
  rp_btn:Lang;
  rpes_title:Lang;
  rpes_titletext:Lang;
  rpt_title:Lang;

  // 携帯電話番号入力
  phoneNumberEnterTitle: Lang
  phoneNumberSubTitle: Lang
  noPhoneNumberTitle: Lang
  phoneNumberErrMsg: Lang
  companyPhoneNumber: Lang
  phoneNumberEmpty: Lang

  // 携帯電話番号入力
  emailEnterTitle: Lang
  noEmailTitle: Lang
  emailEmpty: Lang

  //認証番号入力
  otpVerificationTitle: Lang
  otpNumberErrMsg: Lang
  otpNumberResend: Lang
  otpNumberResendErrMsg: Lang

  //認証番号入力
  emailVerificationTitle: Lang
  emailResendErrMsg: Lang

  //来場者情報入力
  tradeFair: Lang
  tradeFairSubTitle1: Lang
  tradeFairSubTitle2: Lang
  basicInformation: Lang

  buttonSubmit: Lang
  buttonResend: Lang
  backButton: Lang
  phoneNumberInput: Lang
  emailAddressInput: Lang
  otpVerification: Lang
  singup: Lang
  compleleMemberRegistration: Lang

  purposeOfVisit: Lang
  newDeveloping: Lang
  visitToExistingPartners: Lang
  understandingIndustry: Lang
  exhibitionConsideration: Lang
  registRoute: Lang
  registRouteVal: Lang

  select: Lang
  noOption: Lang
  exhibit: Lang
  exhibitConsidering: Lang

  invitationType: Lang
  invitationTypeVal: Lang
}

export const t: Tran = {
  // パスワードの再設定
  rp_title:　{
    ja: 'パスワードの再設定',
    en: 'Password Reset',
    cn: '重设密码',
  },
  rp_titletext:　{
    ja: '再設定用のURLをお送りいたします。ご登録のメールアドレスを入力してください。',
    en: 'We will send you the URL for resetting. Please enter your registered email address.',
    cn: '我们将向您发送用于重置的 URL。 请输入您注册的电子邮件地址。',
  },
  rp_email:　{
    ja: 'ご登録のメールアドレス',
    en: 'Registered email address',
    cn: '注册的电子邮件地址',
  },
  rp_btn:　{
    ja: 'メールの送信',
    en: 'Send email',
    cn: '发电子邮件',
  },
  rpes_title:　{
    ja: 'パスワード再設定用のURLをお送りいたしました。',
    en: 'We have sent you the URL for resetting your password.',
    cn: '我们已向您发送了用于重置密码的 URL。',
  },
  rpes_titletext:　{
    ja: 'メールをご確認下さい。',
    en: 'Please check your email.',
    cn: '请查看你的邮箱。',
  },
  rpt_title:　{
    ja: 'パスワードを変更しました。',
    en: 'Password changed.',
    cn: '密码已更改。',
  },

  // ログイン
  lg_nopass:　{
    ja: 'パスワードをお忘れの方',
    en: 'Forgot password',
    cn: '忘记密码',
  },
  lg_or:　{
    ja: 'または',
    en: 'or',
    cn: '或者',
  },
  lg_signup:　{
    ja: '招待状請求',
    en: 'New registration',
    cn: '新会员注册',
  },
  lg_information:　{
    ja: '閲覧用ID、パスワードがご不明な方はこちら',
    en: 'If you forgot the ID or password, please click here',
    cn: '新会员注册',
  },
  lg_err1:　{
    ja: 'ただいま事務局での確認作業中です。お急ぎの方は、下記事務局までお問い合わせください。',
    en: 'The secretariat is currently in the process of confirming. If you are in a hurry, please contact the secretariat below.',
    cn: '秘书处目前正在确认过程中。 如果您有急事，请联系以下秘书处。',
  },
  lg_err2:　{
    ja: '出展社ページ閲覧用IDまたはパスワードが間違っています。',
    en: 'The ID or password is incorrect.',
    cn: '电子邮件地址或密码不正确。',
  },
  // マイページ
  mp_qr_title:　{
    ja: '現在のご登録情報',
    en: 'Current registration information',
    cn: '当前注册信息',
  },
  mp_qr_check:　{
    ja: '※ご来場前に必ずご確認ください。',
    en: '※Please be sure to check before visiting.',
    cn: '※请务必在访问前检查。',
  },
  mp_qr_title2:　{
    ja: '入場用QR',
    en: 'QR code for admission',
    cn: '入场二维码',
  },
  mp_qr_explain:　{
    ja: '見本市当日は、こちらの入場用QRを印刷してご持参いただくか、スマートフォンに表示していただくことで、 会場へスムーズにご入場いただけます。入場用QRが表示されない方は、「ご来場予定の追加・変更」から、来場予定見本市のご登録をお願いいたします。',
    en: 'On the day of the trade fair, you can print out this QR code and bring it with you, or display it on your smartphone so that you can enter the venue smoothly. If you are not able to see the Entry QR code, please register your trade show plans by clicking "Change your visit plans',
    cn: '展销会当天，您可以打印此二维码随身携带，或显示在您的智能手机上，以便您顺利进场。如果不显示入场登录的QR，请从「预定来场变更」，登录准备参观展会的信息。',
  },
  mp_qr_info1:　{
    ja: '会員コード',
    en: 'Member code',
    cn: '会员代码',
  },
  mp_qr_info2:　{
    ja: 'お名前',
    en: 'Name',
    cn: '姓名',
  },
  mp_qr_info3:　{
    ja: '会社名',
    en: 'Company name',
    cn: '公司',
  },
  mp_qr_visit:　{
    ja: 'ご来場予定',
    en: 'Visit plans',
    cn: '参观日程',
  },
  no_planed:　{
    ja: '登録されているご来場予定はありません。',
    en: 'There are no plans to visit.',
    cn: '没有参观的计划。',
  },
  no_qr:　{
    ja: 'ご来場予定を追加すると入場用QRが表示されます。',
    en: 'Please add your visit plan.',
    cn: '请添加您的访问时间表。',
  },
  mp_qr_visitbtn:　{
    ja: 'ご来場予定の追加・変更',
    en: 'Change your visit plans',
    cn: '参观日程变更',
  },
  mp_result: {
    ja: '検討リスト',
    en: 'Considering',
    cn: '审查清单',
  },
  mp_resultnum: {
    ja: '件',
    en: 'number',
    cn: '号码',
  },
  mp_resultlink: {
    ja: '一覧をみる',
    en: 'More',
    cn: '查看列表',
  },
  mp_menu1: {
    ja: '入場方法',
    en: 'How to enter',
    cn: '如何进入',
  },
  mp_menu2: {
    ja: 'Gift Net',
    en: 'Gift Net',
    cn: 'Gift Net',
  },
  mp_menu3: {
    ja: 'お問い合わせ',
    en: 'inquiry',
    cn: '查询',
  },
  mp_menu1_text: {
    ja: '入場方法についてご確認ください。',
    en: 'Please check how to enter.',
    cn: '请检查如何进入。',
  },
  mp_menu2_text: {
    ja: '出展社・商品検索はこちらから。',
    en: 'Click here to search for exhibitors and products.',
    cn: '单击此处搜索参展商和产品。',
  },
  mp_menu3_text: {
    ja: 'ご不明な点がある方はこちらまで。',
    en: 'If you have any questions, please contact here.',
    cn: '如果您有任何问题，请联系这里。',
  },
  mp_product: {
    ja: 'いいねした商品',
    en: 'Likes',
    cn: '喜欢的产品',
  },
  mp_namecard: {
    ja: '名刺交換履歴',
    en: 'Business card exchange history',
    cn: '名片交换历史',
  },
  mp_meeting: {
    ja: '産地商談会',
    en: 'Local business matching',
    cn: '产区商务会议',
  },
  mp_sfList: {
    ja: 'ビジネスガイド社からのお知らせ',
    en: 'Information',
    cn: '通知',
  },
  mp_login: {
    ja: 'ログイン/招待状請求',
    en: 'Login / New registration',
    cn: '登录/新会员注册',
  },
  mp_login2: {
    ja: 'ログイン 招待状請求',
    en: 'Login, New registration',
    cn: '登录,新会员注册',
  },
  mp_cardname1: {
    ja: '担当者名',
    en: 'Name',
    cn: '负责人姓名',
  },
  mp_cardname2: {
    ja: '住所',
    en: 'Address',
    cn: '地址',
  },
  mp_cardname3: {
    ja: '交換日',
    en: 'Date',
    cn: '交换日期',
  },
  mp_btnTitle: {
    ja: 'その他の情報変更',
    en: 'Change your information',
    cn: '其他信息变更',
  },
  mp_btn1: {
    ja: 'メールアドレスの変更',
    en: 'E-mail address',
    cn: '电子邮件地址更改',
  },
  mp_btn2: {
    ja: 'パスワードの変更',
    en: 'Password',
    cn: '更改密码',
  },
  mp_btn3: {
    ja: 'ご登録情報の変更',
    en: 'Profile',
    cn: '更改注册信息',
  },

  // ご登録情報の変更ページ
  cu_header_title:　{
    ja: 'ご登録情報の変更',
    en: 'Change your profile',
    cn: '更改注册信息',
  },
  cu_title1:　{
    ja: 'ご登録情報',
    en: 'Registered information',
    cn: '注册信息',
  },
  cu_title2:　{
    ja: 'ご登録情報の変更をしてください。 ',
    en: 'Please change your registration information.',
    cn: '请更改您的注册信息。',
  },

  // メールアドレスの変更ページ
  cm_header_title:　{
    ja: 'メールアドレスの変更',
    en: 'E-mail address change',
    cn: '电子邮件地址更改',
  },
  cm_title1:　{
    ja: 'メールアドレス',
    en: 'email address',
    cn: '电子邮件地址',
  },
  cm_title2:　{
    ja: '現在のメールアドレスは以下のとおりです。',
    en: 'The current email address is as follows.',
    cn: '当前的电子邮件地址如下。',
  },
  cm_thanks1:　{
    ja: '変更はまだ完了していません',
    en: 'Changes are not yet complete',
    cn: '更改尚未完成',
  },
  cm_thanks2:　{
    ja: '新しいメールアドレスに、確認用メールをお送りいたしました。',
    en: 'We have sent a confirmation email to your new email address.',
    cn: '我们已向您的新电子邮件地址发送了一封确认电子邮件。',
  },
  cm_thanks3:　{
    ja: 'メールに記載のURLをクリックすると、変更が完了いたします。',
    en: 'Click the URL in the email to complete the change.',
    cn: '单击电子邮件中的 URL 以完成更改。',
  },
  cm_thanks4:　{
    ja: 'なお、メールに記載のURLをクリックするまでは、今までのメールアドレスでログインいただけます。',
    en: 'Until you click the URL in the email, you can log in with your existing email address.',
    cn: '在单击电子邮件中的 URL 之前，您可以使用现有的电子邮件地址登录。',
  },



  // パスワードの変更ページ
  cp_header_title:　{
    ja: 'パスワードの変更',
    en: 'Password address change',
    cn: '更改密码',
  },
  cp_title1:　{
    ja: 'パスワード',
    en: 'Password',
    cn: '密码',
  },
  cp_title2:　{
    ja: '現在のパスワードは以下のとおりです。',
    en: 'The current passwords are.',
    cn: '目前的密码是。',
  },
  cp_title3:　{
    ja: '********（セキュリティ対策のため非表示）',
    en: '******** (Hidden for security measures)',
    cn: '********（出于安全措施隐藏）',
  },
  cp_thanks1:　{
    ja: 'パスワードを変更しました。',
    en: 'Password changed.',
    cn: '密码已更改。',
  },

  // ご来場予定見本市の追加・変更ページ
  cv_title:　{
    ja: 'ご来場予定見本市の追加・変更 ',
    en: 'Information of the upcoming trade show(QR code)',
    cn: '此次参观的贸易展指南',
  },
  cv_sub1_title:　{
    ja: '　入場用QRを追加したい見本市をお選びください。',
    en: '　Trade show you plan  want to add visit QR',
    cn: '　请选择您计划参观的展会',
  },
  cv_msg1:　{
    ja: '※複数来場される場合は～、',
    en: '※If more than one visit',
    cn: '如果多次访问',
  },
  cv_msg2:　{
    ja: '　お申し込み済みの見本市',
    en: '　Trade show that you have already applied for',
    cn: '　您已经申请的贸易展',
  },
  cv_venue:　{
    ja: '会場',
    en: 'Venue',
    cn: '场地',
  },
  cv_header_title: {
    ja: 'ご来場予定の追加',
    en: 'Addition of visit schedule',
    cn: '增加参观日程',
  },
  cv_title1: {
    ja: 'ご来場予定登録',
    en: 'Scheduled visit registration',
    cn: '预约参观登记',
  },

  // 登録完了ページ
  thanks:　{
    ja: '招待状／入場用QR請求を受け付けました。',
    en: 'Thank you for your registration.',
    cn: '感谢您的注册。',
  },

  thanksnote1:　{
    ja: '入場用QRは『マイページ』にログイン後ご確認いただけます。',
    en: 'After confirming your registration details, the organizer will send you link of My Page enter. Please note that it may take up to 3 business days for confirmation.',
    cn: '在确认您的注册信息后，我们将在三个工作日内向您发送有关我们的页面使用指南。',
  },

  thanksnote2:　{
    ja: '招待状は会期２週間前を目安に、ご選択いただいた方法でお送りいたします。ご不明な点は、下記事務局までお問い合わせください。',
    en: 'If you have any questions, please contact the secretariat below.',
    cn: '如果您有任何问题，请联系以下事务处。',
  },

  completed:　{
    ja: '招待状／入場用QR請求完了',
    en: 'Completed',
    cn: '注册完成',
  },

  //招待状/入場用QR 請求フォーム
  signup_top_title: {
    ja: '招待状/入場用QR 請求フォーム',
    en: 'Visitor registration',
    cn: '首次登记注册者',
  },
  signup_top_gift_title: {
    ja: '初めて登録をされる方',
    en: 'Visitor registration',
    cn: '首次登记注册者',
  },
  // ご来場予定選択ページ
  selection_title:　{
    ja: 'ご来場予定見本市のご案内',
    en: 'Information of the upcoming trade show',
    cn: '此次参观的贸易展指南',
  },
  selection_sub1_title:　{
    ja: '　ご来場予定見本市をご選択ください',
    en: '　Please choose trade show you plan to visit',
    cn: '　请选择您计划参观的展会',
  },
  selection_sub2_title:　{
    ja: '　Gift Net®︎（出展社・商品情報検索）閲覧のための会員登録',
    en: '  Sign up for Gift Net',
    cn: '　会员注册浏览礼品网',
  },
  selection_giftnet:　{
    ja: 'B to BポータルサイトGift Net®︎',
    en: 'BtoB Platform of Gift Show exhibitors & products',
    cn: '礼品展B to B综合网站',
  },
  apply_now: {
    ja: '入力フォームへ進む',
    en: 'Go to registration page',
    cn: '进入注册页面',
  },
  delete_now: {
    ja: '来場予定を変更する',
    en: 'Change the visit schedule',
    cn: '删除访问时间表',
  },
  delete_msg: {
    ja: 'ご来場予定を取り消します。よろしいですか？',
    en: 'Your visit schedule will be canceled. Is it OK?',
    cn: '我们将删除您的访问时间表。可以吗？',
  },
  // 事前来場者登録ページ
  advance_title:　{
    ja: '事前来場登録（入場用QR）のご案内',
    en: 'Information of Entry QR code',
    cn: '展前登录注册信息（二维码）指南',
  },
  advance_sub1_title:　{
    ja: '　新型コロナウイルス対策にご協力ください',
    en: 'Please cooperate with prevention of the covid-19 infection. ',
    cn: '请配合新冠病毒的应对措施',
  },
  advance_sub1_1:　{
    ja: '・コロナウイルス感染防止対策として、『分散来場』をお願いしております。',
    en: '・As a measure to prevent the spread of COVID-19, we ask visitors to "adjust the time of visit".',
    cn: '・作为防止 COVID-19 传播的一项措施，我们要求访客“请遵循在指定时间内入场”。',
  },
  advance_sub1_2:　{
    ja: '・ご来場の際は、マスクの着用をお願いします。',
    en: '・Please wear a mask when you come to the venue.',
    cn: '・到会场时请佩戴口罩。',
  },
  advance_sub1_3:　{
    ja: '・会場入り口では、サーモグラフィー等による検温や、消毒液による手指の消毒を実施しております。',
    en: '・At the exhibition hall, we measure the temperature using thermography and disinfect the hands and fingers.',
    cn: '・在展览场地，我们使用热成像仪测量温度并对手指进行消毒。',
  },
  advance_sub1_4:　{
    ja: 'ご協力のほど、よろしくお願いいたします。',
    en: 'Thank you for your cooperation.',
    cn: '谢谢您的合作。',
  },
  advance_sub2_title:　{
    ja: '　事前来場（入場用QR）お申込み',
    en: 'Entry QR code application',
    cn: '事先申请（二维码）',
  },
  advance_sub2_1:　{
    ja: '・事前来場お申込みをいただくことで、入場用QRを取得できます。',
    en: '・You can get a Entry QR code by applying for admission in advance.',
    cn: '・通过提前申请入学可以获得入学QR。',
  },
  advance_sub2_2:　{
    ja: '・入場用QRは、パソコンやスマートフォン等で、マイページから表示することができます。',
    en: '・You can display the Entry QR code from My Page.',
    cn: '・您可以从我的页面显示入场二维码。',
  },
  advance_sub2_3:　{
    ja: '・会期1週間前までにご登録いただいた方には、入場用QR付き招待状をご郵送いたします。',
    en: '・If you register at least one week before the session, we will send you an invitation with a Entry QR code.',
    cn: '・如果您在会议前至少一周注册，我们将向您发送带有二维码的入场邀请函。',
  },
  advance_sub3_1:　{
    ja: '※事前来場登録いただくことで、ご来場前に出展社様の商品や情報検索できる出展社商品情報ポータルサイト『Gift Net®』がご利用できます。ぜひご登録ください。',
    en: '*By registering in advance, you can access the exhibitor product information portal site "Gift Net®" where you can search for exhibitor products and information before visiting. please register.',
    cn: '*通过提前注册，您可以使用参展商产品信息门户网站“Gift Net®”，您可以在访问前搜索参展商产品和信息。 请注册。',
  },
  advance_important1:　{
    ja: '＜見本市へのご来場には、下記が必要となります。＞',
    en: '<The following is required to visit the exhibition. ＞',
    cn: '<以下是参观展览的必需品。 ＞',
  },
  advance_important2:　{
    ja: '①お名刺',
    en: '1. Business card',
    cn: '1. 名片',
  },
  advance_important3:　{
    ja: '②招待状もしくは、入場用QR',
    en: '2. Invitation or Entry QR code',
    cn: '2. 录取通知书或二维码',
  },
  advance_important4:　{
    ja: '※スマートフォン等で入場用QRを表示いただくか、印刷したものをご持参ください。',
    en: '* Please display the Entry QR code on your smartphone or bring a printed copy.',
    cn: '* 请在智能手机上出示入场二维码或携带打印件。',
  },
  advance_non_member1:　{
    ja: '招待状/入場用QR 請求フォーム',
    en: 'Visitor registration',
    cn: '首次登记入场者',
  },
  advance_non_member2:　{
    ja: '初めて事前来場登録される方は、こちらからログイン用の「メールアドレス」「パスワード」、「お名前」「会社情報」等をご登録ください。',
    en: 'If you are registering "My Page" for the first time, please enter your "email address", "password", "name", "company information", "trade show to visit", etc. here.',
    cn:'如果您是第一次进行注册，请从这里注册您的「邮箱地址」及「密码」、请输入「姓名」「公司信息」「想参观的展会」等信息。',
  },
  advance_non_member3:　{
    ja: '※　ご登録内容を確認させていただき、３営業日以内（会期中を除く）に、マイページのご案内を差し上げます。なるべく早めの事前登録をお願いいたします。',
    en: '※　We will confirm your registred informatin and send you message on My Page within 3 business days (except during the exhibition.) Please register before the trade show',
    cn: '※　确认您的注册信息后，我们将在三个工作日内（展会期间除外）向您发送有关我们的页面使用指南。请尽早进行入场注册。',
  },
  advance_non_member4:　{
    ja: '会員登録へすすむ',
    en: 'Proceed to registration',
    cn: '前往会员注册',
  },
  advance_member1:　{
    ja: '既に会員登録を終えられている方',
    en: 'Those who have already completed registration',
    cn: '已经完成会员注册',
  },
  advance_member2:　{
    ja: '既に事前来場登録（マイページ登録）と、事務局による確認を終えられている方は、こちらからログインいただき、 来場予定の見本市をご確認ください。',
    en: 'If you have already registered My Page and confirmed by the organizer, please log in here and check the trade show to visit.',
    cn: '如果您已经完成会员注册，并且得到我们的确认，请在此处登录并查看您计划参观的展览会。',
  },
  advance_member3:　{
    ja: 'ログインする',
    en: 'log in',
    cn: '登录',
  },
  advance_member4:　{
    ja: '>パスワードをお忘れの方',
    en: '> Forgot password',
    cn: '忘记密码',
  },
  footer_officework:
  {
    ja: '事務局窓口',
    en: 'Organizer Office',
    cn: '资讯处窗口',
  },
  footer_tigs:　{
    ja: '東京ギフト・ショー事務局',
    en: 'Tokyo Gift Show Office',
    cn: '东京礼品展组委会办公室',
  },
  footer_ld:　{
    ja: 'ギフト・ショー LIFE×DESIGN事務局',
    en: 'Gift Show LIFE x DESIGN Office',
    cn: '礼品展LIFE×DESIGN组委会办公室',
  },
  footer_landd:　{
    ja: 'LIVING＆DESIGN事務局',
    en: 'LIVING＆DESIGN Office',
    cn: 'LIVING＆DESIGN组委会办公室',
  },
  footer_gds:　{
    ja: 'グルメショー事務局',
    en: 'Gourmet Show Office',
    cn: 'GOURMET SHOW组委会办公室',
  },
  footer_kigs:　{
    ja: '京都ギフト・ショー事務局',
    en: 'Kyoto Gift Show Office',
    cn: '京都礼品展组委会办公室',
  },
  footer_pi:　{
    ja: 'プレミアム・インセンティブショー事務局',
    en: 'Premium Incentive Show Office',
    cn: '国际促销品展组委会办公室',
  },
  footer_osaka:　{
    ja: '京都ギフト・ショー事務局/大阪ギフト・ショー事務局',
    en: 'Kyoto Gift Show Office/Osaka Gift Show Office',
    cn: '京都礼品展组委会办公室/大阪礼品展组委会办公室',
  },
  footer_fukuoka:　{
    ja: '福岡ギフト・ショー／福岡プレミアム・インセンティブショー事務局',
    en: 'Fukuoka Gift Show／Fukuoka Premium Incentive Show Office',
    cn: '福冈礼品展／福冈国际促销品展组委会办公室',
  },
  footertel_tigs:　{
    ja: '(TEL：03-3843-9851／E-Mail：',
    en: '(TEL：+81-3-3843-9851／E-Mail：',
    cn: '(TEL：+81-3-3843-9851／E-Mail：',
  },
  footertel_ld:　{
    ja: '(TEL：03-3843-9711／E-mail：',
    en: '(TEL：+81-3-3843-9711／E-mail：',
    cn: '(TEL：+81-3-3843-9711／E-mail：',
  },
  footertel_landd:　{
    ja: '(TEL：03-3843-9711／E-mail：',
    en: '(TEL：+81-3-3843-9711／E-mail：',
    cn: '(TEL：+81-3-3843-9711／E-mail：',
  },
  footertel_gds:　{
    ja: '(TEL：03-3847-9853／E-mail：',
    en: '(TEL：+81-3-3847-9853／E-mail：',
    cn: '(TEL：+81-3-3847-9853／E-mail：',
  },
  footertel_kigs:　{
    ja: '(TEL：06-6258-0002／E-Mail：',
    en: '(TEL：+81-6-6258-0002／E-Mail：',
    cn: '(TEL：+81-6-6258-0002／E-Mail：',
  },
  footertel_pi:　{
    ja: '(TEL：03-3847-9155／E-Mail：',
    en: '(TEL：+81-3-3847-9155／E-Mail：',
    cn: '(TEL：+81-3-3847-9155／E-Mail：',
  },
  footertel_osaka:　{
    ja: '(TEL：06-6258-0002／E-Mail：',
    en: '(TEL：+81-6-6258-0002／E-Mail：',
    cn: '(TEL：+81-6-6258-0002／E-Mail：',
  },
  footertel_fukuoka:　{
    ja: '(TEL：03-3843-9901／E-Mail：',
    en: '(TEL：+81-3-3843-9901／E-Mail：',
    cn: '(TEL：+81-3-3843-9901／E-Mail：',
  },
  footermail_tigs:　{
    ja: 'n-haga@giftshow.co.jp',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },
  footermail_ld:　{
    ja: 'lifedesign@giftshow.co.jp',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },
  footermail_landd:　{
    ja: 'info@living-and-design.com',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },
  footermail_gds:　{
    ja: 'info@gourmetshow.jp',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },
  footermail_kigs:　{
    ja: 'giftwest@businessguide-sha.co.jp',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },
  footermail_pi:　{
    ja: 'premium@giftshow.co.jp',
    en: 'premium@giftshow.co.jp',
    cn: 'premium@giftshow.co.jp',
  },
  footermail_osaka:　{
    ja: 'giftwest@businessguide-sha.co.jp',
    en: 'giftwest@businessguide-sha.co.jp',
    cn: 'giftwest@businessguide-sha.co.jp',
  },
  footermail_fukuoka:　{
    ja: 'fukuoka@giftshow.co.jp',
    en: 'overseas@businessguide-sha.co.jp',
    cn: 'overseas@businessguide-sha.co.jp',
  },

  // 各種リンク用
  herelogin:　{
    ja: 'registration/login.html',
    en: 'registration/login.html',
    cn: 'registration/login.html',//暫定
  },

  note2URL:　{
    ja: 'https://www.giftshow.co.jp/aboutus/privacy.htm',
    en: 'https://www.giftshow.co.jp/english/aboutus/privacy.htm',
    cn: 'https://www.giftshow.co.jp/aboutus/privacy.htm',//暫定
  },

  note4URL:　{
    ja: 'https://www.giftshow.co.jp/aboutus/securitypolicy.htm',
    en: 'https://www.giftshow.co.jp/aboutus/securitypolicy.htm',
    cn: 'https://www.giftshow.co.jp/aboutus/securitypolicy.htm',//暫定
  },

  preftop:　{
    ja: '都道府県をお選びください',
    en: 'Please select a Prefecture',
    cn: '请选择都道府县',
  },

  induscatetop:　{
    ja: '業種カテゴリーをお選びください',
    en: 'Please select an industry',
    cn: '请选择行业类别',
  },
  industop:　{
    ja: '業種をお選びください',
    en: 'Please select an industry',
    cn: '请选择行业',
  },
  itemcatetop:　{
    ja: '主力商品カテゴリーをお選びください',
    en: 'Please select a main product category',
    cn: '请选择主要产品类别',
  },
  itemtop:　{
    ja: '主力商品をお選びください',
    en: 'Please select a main product handled',
    cn: '请选择主要产品',
  },

  occutop:　{
    ja: '職種をお選びください',
    en: 'Please select an occupation',
    cn: '请选择职务类型',
  },

  roletop:　{
    ja: '購買決定権をお選びください',
    en: 'Please tell us your role for purchasing decision',
    cn: '请选择购买决定权',
  },
  
  pricetop:　{
    ja: '購買決定額をお選びください',
    en: 'Please select the budget decision amount',
    cn: '请选择购买决定金额',
  },

  countriestop:　{
    ja: '国をお選びください',
    en: 'Please select a country',
    cn: '请选择国家',
  },

  // 情報登録画面
  infotop:　{
    ja: '基本情報',
    en: 'Basic information',
    cn: '基本信息',
  },

  required:　{
    ja: '（必須）',
    en: '(required)',
    cn: '（必须）',
  },

  firstName:　{
    ja: '姓',
    en: 'Family name',
    cn: '姓',
  },

  firstNamevl:　{
    ja: '姓を入力してください。',
    en: 'Please enter your family name.',
    cn: '请输入您的姓。',
  },

  lastName:　{
    ja: '名',
    en: 'First name',
    cn: '名',
  },

  lastNamevl:　{
    ja: '名を入力してください。',
    en: 'Please enter your name.',
    cn: '请输入您的名。',
  },

  firstNamekana:　{
    ja: 'セイ',
    en: 'Please enter your Last-name',
    cn: '姓（片假名）',
  },

  lastNamekana:　{
    ja: 'メイ',
    en: 'Please enter your First-name',
    cn: '名（片假名）',
  },

  email:　{
    ja: 'メールアドレス',
    en: 'E-mail',
    cn: '邮箱地址',
  },

  email_confirm:　{
    ja: 'メールアドレス（確認）',
    en: 'E-mail Confirmation',
    cn: '邮箱地址（确认）',
  },

  emailvl:　{
    ja: '有効なメールアドレスを入力してください。',
    en: 'Please enter a valid e-mail address.',
    cn: '请输入有效的邮箱地址。',
  },

  giftnetid:　{
    ja: '出展社ページ閲覧用ID',
    en: 'ID',
    cn: 'ID',
  },

  giftnetidvl:　{
    ja: '有効なIDを入力してください。',
    en: 'Please enter a valid ID.',
    cn: '请输入有效的邮箱地址。',
  },

  emailerrmsg:{
    ja: 'このメールアドレスは、過去にご登録いただいております。→こちらからログインの上、ご確認ください',
    en: 'This e-mail address has been registered in the past. → Please log in from here to check',
    cn: '此电子邮件地址已在过去注册。 → 请从这里登录查看。',
  },

  emailcaution:　{
    ja: '※一度ご利用いただいたメールアドレスは使用することができませんのでご注意ください。',
    en: '* The same e-mail address cannot be used for multiple accounts',
    cn: '※已经被注册的邮箱地址。',
  },

  phoneNumber:　{
    ja: '携帯電話番号',
    en: 'Mobile number',
    cn: '手机号码',
  },

  phoneNumbervl:　{
    ja: '有効な電話番号を入力してください。',
    en: 'Please enter a valid mobile number.',
    cn: '请输入有效的手机号码。',
  },

  phoneNumberEmpty:　{
    ja: '電話番号を入力してください。',
    en: 'Please enter your mobile number.',
    cn: '请输入有效的手机号码。',
  },

  phoneNumberErrMsg:　{
    ja: '有効な携帯番号を入力してない。',
    en: 'You have not entered a valid mobile number.',
    cn: '您没有输入有效的手机号码。',
  },

  password:　{
    ja: 'パスワード',
    en: 'password',
    cn: '密码',
  },

  password_confirm:　{
    ja: 'パスワード（確認）',
    en: 'password(Verification)',
    cn: '密码（确认）',
  },

  passwordvl:　{
    ja: '有効なパスワードを入力してください。',
    en: 'The password must be more than 8 letters and less than 16 letters in Half-Width Alphanumeric Character.',
    cn: '请输入有效的密码。',
  },

  companyinfo1:　{
    ja: '企業情報１',
    en: 'Corporate information 1',
    cn: '企业信息1',
  },

  companyName:　{
    ja: '会社名・屋号',
    en: 'Company name / store name',
    cn: '公司/店铺名称',
  },

  companyNameNotion:　{
    ja: '※会社名欄に、「個人名」「一般」「学生」「個人」等、会社名や屋号以外を記入された方には、招待状や入場用QRは届きません。',
    en: '',
    cn: '',
  },

  companyNameKana:　{
    ja: '会社名・屋号（カナ）',
    en: 'Company name / store name(Kana)',
    cn: '公司/店铺名称（片假名）',
  },

  departmentName:　{
    ja: '部署',
    en: 'Department',
    cn: '部门',
  },

  positionName:　{
    ja: '役職',
    en: 'Job Title',
    cn: '职位',
  },

  companyNameval:　{
    ja: '会社名・屋号を入力してください。',
    en: 'Please enter the company name and store name.',
    cn: '请输入公司或店铺名称。',
  },

  departmentNameval:　{
    ja: '部署を入力してください。',
    en: 'Please enter the department.',
    cn: '请输入部门。',
  },

  positionNameval:　{
    ja: '役職を入力してください。',
    en: 'Please enter your job title.',
    cn: '请输入职位。',
  },

  postalNumber:　{
    ja: '郵便番号',
    en: 'Postal code',
    cn: '邮政编码',
  },

  postalNumberval:　{
    ja: '郵便番号を入力してください。',
    en: 'Please enter your zip code.',
    cn: '请输入邮政编码。',
  },

  prefectures:　{
    ja: '都道府県',
    en: 'Prefectures',
    cn: '都道府县',
  },

  prefecturesval:　{
    ja: '都道府県を入力してください。',
    en: 'Please enter the prefecture.',
    cn: '请输入都道府县。',
  },

  address1:　{
    ja: '市区町村',
    en: 'City',
    cn: '地址1',
  },

  address1val:　{
    ja: '市区町村を入力してください。',
    en: 'Please enter city.',
    cn: '请输入地址1。',
  },

  address2:　{
    ja: '番地',
    en: 'Address',
    cn: '地址2',
  },

  address2val:　{
    ja: '番地を入力してください。',
    en: 'Please enter address.',
    cn: '请输入地址2。',
  },

  address3:　{
    ja: 'ビル名',
    en: 'Building',
    cn: '地址3',
  },

  tel:　{
    ja: '電話番号',
    en: 'phone number',
    cn: '电话号码',
  },

  telval:　{
    ja: '有効な電話番号を入力してください。',
    en: 'Please enter a valid Tel number.',
    cn: '请输入有效的电话号码。',
  },

  companyinfo2:　{
    ja: '企業情報２',
    en: 'Corporate information 2',
    cn: '公司信息2',
  },

  industry:　{
    ja: '業種',
    en: 'Industry',
    cn: '行业',
  },

  industryval:　{
    ja: '業種を選択してください。',
    en: 'Please select an industry.',
    cn: '请选择行业。',
  },

  industry_other:　{
    ja: 'その他の業種',
    en: 'Other',
    cn: '其他行业',
  },

  industry_otherval:　{
    ja: 'その他の業種を入力してください。',
    en: 'Please enter other nature of business.',
    cn: '请输入其他行业。',
  },

  product:　{
    ja: '主力商品',
    en: 'Main product',
    cn: '主要商品',
  },

  productval:　{
    ja: '主力商品を選択してください。',
    en: 'Please select the main product.',
    cn: '请选择主要商品。',
  },

  product_other:　{
    ja: 'その他の主力商品',
    en: 'Other main products',
    cn: '其他主要商品',
  },

  product_otherval:　{
    ja: 'その他の主力商品を入力してください。',
    en: 'Please enter other flagship products.',
    cn: '请输入其他主要商品。',
  },

  occupation:　{
    ja: '職種',
    en: 'Occupation',
    cn: '职位',
  },

  occupationval:　{
    ja: '職種を選択してください。',
    en: 'Please select an occupation.',
    cn: '请输入职位。',
  },

  role:　{
    ja: '購買決定権',
    en: 'Purchasing decision',
    cn: '购买决定权',
  },

  roleval:　{
    ja: '購買決定権を選択してください。',
    en: 'Select a purchasing decision right.',
    cn: '请选择购买决定权。',
  },

  price:　{
    ja: '購買決定額',
    en: 'Purchase decision amount',
    cn: '购买决定金额',
  },

  priceval:　{
    ja: '購買決定額を選択してください。',
    en: 'Please select the budget decision amount.',
    cn: '请选择购买决定金额。',
  },

  abroad:　{
    ja: '海外から商品を仕入れている',
    en: 'Purchasing products from overseas',
    cn: '从海外采购商品',
  },

  mail_subscription:　{
    ja: 'メルマガ配信',
    en: 'E-mail magazine delivery',
    cn: '邮箱投递宣传信息',
  },

  dm_subscription:　{
    ja: 'DMの郵送',
    en: 'DM mailing',
    cn: '直接邮寄',
  },

  subscribe:　{
    ja: '「月刊ぎふとPREMIUM」（有料：1年間￥11,000）の購読をする',
    en: 'Subscription to "Gift PREMIUM" (paid)',
    cn: '訂閱“Gift PREMIUM”（付費）',
  },

  note:　{
    ja: '【個人情報のお取り扱いについて】',
    en: '【Handling of personal information】',
    cn: '【关于个人信息的处理】',
  },

  agreewithall:　{
    ja: '上記案内事項に全て同意する',
    en: 'I agree with all the above guidance',
    cn: '我同意以上所有说明事项',
  },

  Check:　{
    ja: '入力内容を確認する',
    en: 'Confirm',
    cn: '输入内容确认',
  },

  back:　{
    ja: '戻る',
    en: 'Back',
    cn: '返回',
  },

  confirm:　{
    ja: 'この内容で登録する',
    en: 'Confirm',
    cn: '注册此内容',
  },

  click_alert:　{
    ja: 'ボタンは１度だけ押してください。ダブルクリックはしないでください。',
    en: 'Press the button only once. Do not double-click.',
    cn: '只需按一次按钮。 不要双击。',
  },

  yes:　{
    ja: 'はい',
    en: 'yes',
    cn: '是',
  },

  no:　{
    ja: 'いいえ',
    en: 'no',
    cn: '否',
  },

  close: {
    ja: "閉じる",
    en: "close",
    cn: "特写",
  },
  
  hope:　{
    ja: '希望する',
    en: 'Yes',
    cn: '希望',
  },

  nothope:　{
    ja: '希望しない',
    en: 'No',
    cn: '不希望',
  },

  note1:　{
    ja: '※株式会社ビジネスガイド社（以下、「当社」といいます。）は、個人情報の保護に努めることは社会的責務として大変重要なことであると考えております。当社のサービスにおいてはお客様から個人情報をお預かりするにあたり、',
    en: '* Business Guide-sha, Inc. (hereinafter referred to as "the Company") considers that it is very important as a social responsibility to strive to protect personal information. In our service, when we receive personal information from customers,',
    cn: '※Business Guide 有限公司（以下简称“本公司”）为保护个人信息作为本公司的重要责任。我们制定了',
  },
  
  note2:　{
    ja: '「個人情報保護方針（プライバシーポリシー）」',
    en: '"Personal information protection policy (privacy policy)"',
    cn: '「个人信息保护方针（隐私政策）」',
  },
  
  note3:　{
    ja: '及び',
    en: 'as well as',
    cn: '以及',
  },
  
  note4:　{
    ja: '「情報セキュリティポリシー」',
    en: '"Information security policy"',
    cn: '「信息安全政策」',
  },
  
  note5:　{
    ja: 'を制定し、大切な個人情報の適正な管理と利用、保護に努めております。今後もお客様に安心して当社のサービスをご利用いただくため、個人情報保護に関わる法令を遵守し、お客様の個人情報の保護に最大限注力して参ります。',
    en: 'We are striving to properly manage, use, and protect important personal information. In order for our customers to continue to use our services with peace of mind, we will comply with laws and regulations related to the protection of personal information and will make every effort to protect our customers'+ "'"+' personal information.',
    cn: '的正确管理、使用和保护个人的重要信息。为让我们的客户安心地继续使用我们的服务，我们将遵守有关个人信息保护的法律法规，并尽一切努力来保护我们客户的个人信息。',
  },

  Plannedmarket:　{
    ja: 'ご来場予定見本市',
    en: 'Trade shows to visit',
    cn: '计划参观展会',
  },

  emergencyContactValue:　{
    ja: '携帯電話番号',
    en: 'Emergency Contact',
    cn: '手机号码',
  },

  emergencyContactValuevl:　{
    ja: '有効な携帯電話番号を入力してください。',
    en: 'Please enter a valid mobile number.',
    cn: '请输入有效的手机号码。',
  },

  Residential_areas:　{
    ja: '居住地域',
    en: 'Residential areas',
    cn: '居住地区',
  },

  areaIndexboxval:　{
    ja: '居住地域を選択してください。',
    en: 'Please select your area of residence.',
    cn: '请选择居住地区。',
  },

  country:　{
    ja: '国',
    en: 'country',
    cn: '国家',
  },

  countryval:　{
    ja: '国を選択してください。',
    en: 'Please select a country.',
    cn: '请选择国家。',
  },

  nextjoin_q:　{
    ja: '貴社の出展は検討はしていますか？',
    en: 'Are you considering exhibiting at your company?',
    cn: '贵公司是否在考虑参展？',
  },

  nextjoin_qval:　{
    ja: '該当の項目を選択してください。',
    en: 'Please select the applicable item.',
    cn: '请选择适用的项目。',
  },

  Areconsidering:　{
    ja: '次回出展を検討している　※来場ではございません',
    en: 'Considering future exhibiting',
    cn: '正在考虑参加下届展览会',
  },

  Areconsideringval:　{
    ja: '選択してください。',
    en: 'Please select.',
    cn: '请选择。',
  },

  Multipleselectionspossible:　{
    ja: '複数選択可',
    en: 'Multiple selections possible',
    cn: '可以多选',
  },

  purpose:　{
    ja: '来場目的：',
    en: 'Purpose of visit:',
    cn: '来访目的：',
  },

  purposeval:　{
    ja: '来場目的を１つ以上チェックしてください',
    en: 'Please check one or more purposes of your visit',
    cn: '请选择一个以上的来访目的',
  },

  giftnet_topbtn:　{
    ja: '請求フォームTOPへ',
    en: 'Go to the top page',
    cn: '转到首页',
  },

  //ギフトネット コード分け
  top: {
    ja: '　招待状請求',
    en: '　Registration',
    cn: '　邀请请求',
  },
  logintext: {
    ja: 'すでにご登録されている方はこちらからログインいただけます。',
    en: 'If you have already registered you can log in here',
    cn: '如果您已经注册您可以从，',
  },
  loginurl: {
    ja: 'ログインページへ',
    en: 'Login page',
    cn: '登录页面',
  },
  getcodehead: {
    ja: '7桁×7桁の来場者コードをお持ちの方',
    en: 'Those who have a 7-digit x 7-digit visitor code',
    cn: '持有 7 位 x 7 位编码的用户',
  },
  getcodeouttext: {
    ja: '案内状に記載のコードを入力してください',
    en: 'Please enter the code on the invitation',
    cn: '请输入邀请函上的编码',
  },
  getcodesubmit: {
    ja: 'コードを入力してご登録へ進む',
    en: 'Enter the code to proceed to registration',
    cn: '输入编码后继续注册',
  },
  notcodehead: {
    ja: '案内状をお持ちでない方',
    en: 'Those who do not have a letter of invitation',
    cn: '未持有邀请函',
  },
  notcodehead2: {
    ja: '来場者コードの記載がない方',
    en: 'Those who do not have a visitor code',
    cn: '邀请码的用户',
  },
  notcodeouttext: {
    ja: 'そのままご登録にお進みください',
    en: 'Please proceed to registration as it is',
    cn: '请直接进行注册',
  },
  notcodesubmit: {
    ja: 'ご登録へ進む',
    en: 'Proceed to registration',
    cn: '继续注册',
  },
  info1: {
    ja: 'お申し込みの際にご登録いただきましたお客様の情報は、本見本市の運用をはじめ、各種情報のご提供、アンケートのご依頼、及び株式会社ビジネスガイド社営業部門からのコンタクトなどに利用させていただく場合があります。',
    en: 'The registered My Page information might be used for the operation of the trade show, provision of various information, request for questionnaires, and contact from the sales department of Business Guide-Sha,Inc.',
    cn: '您申请时登记的客户信息将运用于本展览会各种信息提供、问卷调查、以及来自于本公司营业部的联络等方面。',
  },
  info2: {
    ja: 'なお、上記以外の目的には利用いたしません。お客様の登録情報の開示、訂正、削除のお申出があったときは速やかに対応いたします。',
    en: 'In addition, we will not use it for purposes other than the above. We will promptly respond to requests for disclosure, correction, or deletion of your registred information.',
    cn: '另外，我们不会将其用于上述以外的目的。 如果您想更正或删除您注册信息，我们会及时回应。',
  },
  codeTitle: {
    ja: '7桁×7桁の来場者コード：',
    en: '7-digit x 7-digit visitor code：',
    cn: '7 位 x 7 位编码：',
  },


  // 共通
  contact: {
    ja: 'お問い合わせ',
    en: 'Contact',
    cn: '联系我们',
  },
  loading: {
    ja: '読み込み中です',
    en: 'Loading',
    cn: '正在加载',
  },
  api_fail: {
    ja: '通信エラーが発生しました。もう一度データの取得を行いますか？',
    en: 'A communication error has occurred. Would you like to get the data again?',
    cn: '发生通信错误。 您想再次获取数据吗？',
  },
  registration: {
    ja: '新規登録',
    en: 'Join Free',
    cn: '注册',
  },
  login: {
    ja: 'ログイン',
    en: 'Login',
    cn: '登录',
  },
  logout: {
    ja: 'ログアウト',
    en: 'Logout',
    cn: '登出',
  },
  faq_here: {
    ja: 'よくあるご質問はこちら',
    en: 'FAQ',
    cn: 'FAQ',
  },
  faq: {
    ja: 'よくあるご質問',
    en: 'FAQ',
    cn: 'FAQ',
  },
  guide: {
    ja: '使い方ガイド',
    en: 'How to Use Guide',
    cn: '指南',
  },
  mypage_top: {
    ja: 'マイページTOPへ',
    en: 'Go to My Page TOP',
    cn: '前往我的主页 TOP',
  },

  // エラーメッセージ
  errNeedLogin: {
    ja: 'ログインが必要です',
    en: 'You need to Log in',
    cn: '需要登录',
  },
  errRegisterFavorite: {
    ja: 'お気に入りを登録するにはログインが必要です',
    en: 'You must be logged in to register your favorites',
    cn: '您需要登录才能注册您的收藏夹',
  },
  errRemoveFavorite: {
    ja: 'お気に入りの登録解除に失敗しました',
    en: 'Failed to remove it from my favorites',
    cn: '无法取消注册收藏夹',
  },
  errPassword1: {
    ja: 'パスワードは半角英数字8文字以上16字以下で入力してください。',
    en: 'Please enter the password using 8 to 16 single-byte alphanumeric characters.',
    cn: '请使用 8 到 16 个单字节字母数字字符输入密码。',
  },
  errPassword2: {
    ja: '確認用パスワードは半角英数字8文字以上16字以下で入力してください。',
    en: 'Please enter the confirmation password using 8 to 16 single-byte alphanumeric characters.',
    cn: '请使用 8 到 16 个单字节字母数字字符输入确认密码。',
  },
  errPassword3: {
    ja: 'パスワードと確認用パスワードが一致しません。',
    en: 'The password and confirmation password do not match.',
    cn: '密码和确认密码不匹配。',
  }, 
  errPassword4: {
    ja: '確認用パスワードと一致しません。',
    en: 'It does not match the confirmation password.',
    cn: '它与确认密码不匹配。',
  }, 
  errPassword5: {
    ja: 'パスワードと一致しません。',
    en: 'Does not match the password.',
    cn: '与密码不符。',
  }, 
  errEmail1: {
    ja: '確認用メールアドレスと一致しません。',
    en: 'It does not match the confirmation email address.',
    cn: '它与确认电子邮件地址不匹配。',
  }, 
  errEmail2: {
    ja: 'メールアドレスと一致しません。',
    en: 'It does not match your email address.',
    cn: '它与您的电子邮件地址不匹配。',
  }, 
  errEmail3: {
    ja: '有効なメールアドレスを入力してください。',
    en: 'Please enter a valid email address.',
    cn: '请输入有效的电子邮件地址。',
  }, 
  errPost1: {
    ja: '正しい郵便番号を入力してください。',
    en: 'Please enter the correct zip code.',
    cn: '请输入正确的邮政编码。',
  }, 
  // 入力欄例
  familyNameplaceholder: {
    ja: '例）ぎふと',
    en: '',
    cn: '',
  },
  lastNameplaceholder: {
    ja: '例）太郎',
    en: '',
    cn: '',
  },
  firstNamekanaplaceholder: {
    ja: '例）ギフト',
    en: '',
    cn: '',
  },
  lastNamekanaplaceholder: {
    ja: '例）タロウ',
    en: '',
    cn: '',
  },
  emailplaceholder: {
    ja: '例）gift@businessguide-sha.co.jp',
    en: '',
    cn: '',
  },
  email_confirmplaceholder: {
    ja: '例）gift@businessguide-sha.co.jp',
    en: '',
    cn: '',
  },
  emergencyContactValueplaceholder: {
    ja: '例）03-3843-9850',
    en: '',
    cn: '',
  },
  passwordplaceholder: {
    ja: '半角英数字8文字以上16文字以下',
    en: '',
    cn: '',
  },
  password_confirmplaceholder: {
    ja: '半角英数字8文字以上16文字以下',
    en: '',
    cn: '',
  },
  companyNameplaceholder: {
    ja: '例）株式会社ビジネスガイド社',
    en: '',
    cn: '',
  },
  companyNameKanaplaceholder: {
    ja: '例）カブシキガイシャビジネスガイドシャ',
    en: '',
    cn: '',
  },
  departmentplaceholder: {
    ja: 'ない場合は「なし」',
    en: '',
    cn: '',
  },
  zipCodeplaceholder: {
    ja: '例）111-0034',
    en: '',
    cn: '',
  },
  cityplaceholder: {
    ja: '例）台東区',
    en: '',
    cn: '',
  },
  houseNumberplaceholder: {
    ja: '例）雷門2-6-2',
    en: '',
    cn: '',
  },
  buildingplaceholder: {
    ja: '例）ぎふとビル',
    en: '',
    cn: '',
  },
  phoneNumberplaceholder: {
    ja: '例）03-3843-9850',
    en: '',
    cn: '',
  },

  //携帯電話番号入力
  phoneNumberEnterTitle: {
    ja: '携帯電話番号を入力してください',
    en: 'Please enter your mobile phone number',
    cn: '请输入您的手机号码',
  },

  phoneNumberSubTitle: {
    ja: '（招待状請求は無料です）',
    en: 'Invitation request is free!',
    cn: '邀请请求是免费的',
  },

  noPhoneNumberTitle: {
    ja: '日本の携帯電話をお持ちでない方はこちら',
    en: 'Click here if you do not have a Japanese mobile phone',
    cn: '如果您没有日本手机，请单击此处',
  },

  buttonSubmit: {
    ja: '送信する',
    en: 'Send',
    cn: '发送',
  },

  buttonResend: {
    ja: '再送する',
    en: 'Resend',
    cn: '重发',
  },

  backButton: {
    ja: '戻る',
    en: 'Return',
    cn: '返回',
  },

  phoneNumberInput: {
    ja: '認証番号送信先入力',
    en: 'Enter phone number or e-mail',
    cn: '输入电话号码或电子邮件地址',
  },

  emailAddressInput: {
    ja: 'メール入力',
    en: 'Enter email address',
    cn: '电子邮件输入',
  },

  otpVerification: {
    ja: '認証番号入力（3分以内）',
    en: 'Enter verification number(within 3min.)',
    cn: '输入验证号(3分钟内有效)',
  },

  singup: {
    ja: '来場者情報入力',
    en: 'Enter member information',
    cn: '输入会员信息',
  },

  compleleMemberRegistration: {
    ja: '招待状／入場用QR請求完了',
    en: 'Completed',
    cn: '会员注册完成',
  },

  otpVerificationTitle: {
    ja: 'ショートメールに届いた認証番号を入力してください',
    en: 'Please enter the verification code',
    cn: '请输入您手机收到的短信验证码',
  },

  otpNumberErrMsg: {
    ja: '認証番号が正しくありません',
    en: 'Authentication number is incorrect',
    cn: '认证号码不正确',
  },

  otpNumberResend: {
    ja: '認証番号を再送する',
    en: 'Resend verification number',
    cn: '重新发送验证号',
  },

  otpNumberResendErrMsg: {
    ja: '認証番号を送信しました。',
    en: 'A confirmation number has been sent to your mobile.',
    cn: '确认号码已发送到您的手机。',
  },

  tradeFair: {
    ja: 'ご来場予定見本市',
    en: 'Trade fairs to attend',
    cn: '参加的交易会',
  },

  tradeFairSubTitle1: {
    ja: '携帯に届いたSMSの認証番号を入力してください',
    en: 'The 4th Kyoto International Gift Show 2023',
    cn: '2023第四届京都国际礼品展',
  },

  tradeFairSubTitle2: {
    ja: '2023年3月8日（水）～3月9日（木）',
    en: 'March 8 (Wednesday) to March 9 (Thursday), 2023',
    cn: '2023 年 3 月 8 日（星期三）至 3 月 9 日（星期四）',
  },

  basicInformation: {
    ja: '基本情報',
    en: 'Basic information',
    cn: '基本信息',
  },

  companyPhoneNumber: {
    ja: '会社電話番号',
    en: 'Company phone number',
    cn: '公司电话号码',
  },

  purposeOfVisit: {
    ja: '来場目的：複数選択可',
    en: 'Purpose of visit: Multiple selections possible',
    cn: '参观目的：可多选',
  },

  newDeveloping: {
    ja: '新規取引先の開拓や新商品の発掘',
    en: 'Developing new business partners and discovering new products',
    cn: '开发新的商业伙伴和发现新产品',
  },

  visitToExistingPartners: {
    ja: '既存取引先への訪問',
    en: 'Company phone number',
    cn: '拜访现有的商业伙伴',
  },

  understandingIndustry: {
    ja: '業界動向の把握・情報収集',
    en: 'Understanding industry trends and collecting information',
    cn: '了解行业趋势并收集信息',
  },

  exhibitionConsideration: {
    ja: '出展検討',
    en: 'Exhibition consideration',
    cn: '展览考虑',
  },

  registRoute: {
    ja: '当社の見本市をどこで知りましたか？',
    en: 'Where did you hear about our exhibition?',
    cn: '您从哪里得知我们的展览？',
  },

  registRouteVal: {
    ja: '当社の見本市を知ったルートを入力してください。',
    en: 'Please enter the route to know our exhibition.',
    cn: '请输入路线了解我们的展览。',
  },

  select: {
    ja: '選択してください。',
    en: 'Please select.',
    cn: '请选择。',
  },

  noOption: {
    ja: '該当なし',
    en: 'N/A',
    cn: '不适用',
  },

  exhibit: {
    ja: '出展を希望する',
    en: 'I would like to exhibit',
    cn: '我想参展',
  },

  exhibitConsidering: {
    ja: '出展を検討したいので詳しい資料がほしい',
    en: 'I want to consider exhibiting, so I need detailed materials',
    cn: '我想考虑参展，所以我需要详细的材料',
  },

  //携帯電話番号入力
  emailEnterTitle: {
    ja: 'メールアドレスを入力してください',
    en: 'Please enter your e-mail address',
    cn: '请输入您的电子邮件地址',
  },

  noEmailTitle: {
    ja: '日本の携帯電話をお持ちの方はこちら',
    en: 'Click here if you have a Japanese mobile phone',
    cn: '如果您有日本手机，请单击此处',
  },

  emailEmpty:　{
    ja: 'メールアドレスを入力してください。',
    en: 'Please enter your e-mail address.',
    cn: '请输入您的电子邮件地址。',
  },

  emailVerificationTitle: {
    ja: 'メールアドレスに届いた認証番号を入力してください',
    en: 'Please enter the verification code sent to your email address',
    cn: '请输入发送到您邮箱的验证码',
  },

  emailResendErrMsg: {
    ja: '認証番号を送信しました。',
    en: 'A confirmation number has been sent to your email address.',
    cn: '确认号码已发送至您的电子邮箱。',
  },

  invitationType: {
    ja: '招待状（入場用QR）の受け取り方法',
    en: 'Invitation type.',
    cn: '邀请函的获取方式.'
  },

  invitationTypeVal: {
    ja: '招待状の種類をお選びください',
    en: 'Select invitation type.',
    cn: '请选择邀请函的获取方式'
  }
};

export const translate = (lang: keyof Lang) => {
  $('.trn').each((_, e) => {
    const trn_key = $(e).data('trn-key') as keyof Tran;
    if (trn_key in t) {
      $(e).text(t[trn_key][lang]);
      if ($(e).is('input')) $(e).attr('placeholder', t[trn_key][lang]);
    }
  });
};

// 翻訳する
const run = () => {
  const lsLang = localStorage.getItem('lang') as keyof Lang | null;
  if (lsLang) {
    translate(lsLang);
    $('.trn-lang').each((_, el) => {
      const _lang = $(el).data('value') as keyof Lang;
      if (_lang === lsLang) {
        $(el).addClass('active');
      } else {
        $(el).removeClass('active');
      }
    });
  } else {
    translate('ja');
    localStorage.setItem('lang', 'ja');
  }
};

export default run;